export default __webpack_public_path__ + "static/media/human_chest.9012bc08.png";